import { Expenses } from "features/Expenses/Expenses";
import { Salary } from "features/Salary/Salary";

import styles from "./styles.module.scss";

export const ExpensesPage = (): JSX.Element => (
  <div className={styles.main}>
    <Expenses />
    <Salary />
  </div>
);
